import { getMessage } from "../data/locales";

/**
 * Course material file upload: must match AcademiaBackend limits for direct R2 upload
 * and multipart. Cap is 5GB.
 */
export const COURSE_MATERIAL_MAX_FILE_BYTES = 5 * 1024 * 1024 * 1024;

export function getCourseMaterialMaxFileMbInteger() {
  return COURSE_MATERIAL_MAX_FILE_BYTES / (1024 * 1024);
}

/** Human label with space, e.g. "5120 MB". */
export function getCourseMaterialMaxFileLabel() {
  return `${getCourseMaterialMaxFileMbInteger()} MB`;
}

/** @deprecated Prefer getCourseMaterialMaxFileLabel(); kept for existing compact call sites. */
export function getCourseMaterialMaxFileLabelCompact() {
  return getCourseMaterialMaxFileLabel();
}

/**
 * User-facing copy when a selected/uploaded file exceeds the limit (AO-280).
 * Validated client-side before any network upload starts.
 */
export function getCourseMaterialOversizedFileMessage() {
  return getMessage("courseEditor.fileTooLarge", {
    maxSize: getCourseMaterialMaxFileLabel(),
  });
}

export function getCourseMaterialOversizedSelectionMessage() {
  return getMessage("courseEditor.fileTooLargeSelected", {
    maxSize: getCourseMaterialMaxFileLabel(),
  });
}

export function isCourseMaterialFileOversized(file) {
  return Boolean(file && typeof file.size === "number" && file.size > COURSE_MATERIAL_MAX_FILE_BYTES);
}
